import { slugify } from '@/utils/string';

export function buildProductSkuPreview(name: string): string {
  const normalized = slugify(name).replace(/-/g, '').toUpperCase();
  const prefix = normalized.slice(0, 4).padEnd(4, 'X');

  let hash = 0;
  for (const char of normalized) {
    hash = (hash * 31 + char.charCodeAt(0)) % 1679616;
  }

  const suffix = hash.toString(36).toUpperCase().padStart(4, '0').slice(-4);
  return `${prefix}${suffix}`;
}

export function buildVariantSkuPreview(productSku: string, valueSlugs: string[]): string {
  const codes = valueSlugs
    .map((slug) => slug.replace(/[^a-z0-9]/gi, '').charAt(0).toUpperCase())
    .filter(Boolean)
    .join('');

  return `${productSku}-${codes || 'VAR'}`;
}
